import { Record, List } from 'immutable'
import { createReducer } from '_utils/redux'
import { GET_LABOR_TYPES } from './actions'

const INITIAL_STATE = new Record({
  results: List(),
  count: 0,
})()

const laborTypes = createReducer(INITIAL_STATE, {
  [GET_LABOR_TYPES.FULFILLED]: (state, { payload }) => {
    return state.set('results', payload.results ?? payload ?? []).set('count', payload.count ?? 0)
  },
})

export default laborTypes
